<template>
    <div>
        <div class="row" v-if="actionPlan.id">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Criar Plano de Ação</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nameInput">Nome</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="actionPlan.name"
                                        readonly
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="placeInput">Local</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="actionPlan.place"
                                        readonly
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Responsável</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="actionPlan.responsible.name"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="actionStartInput">Início</label>
                                    <date-picker
                                        :value="actionPlan.start_date"
                                        :output-format="'YYYY-MM-DD HH:mm'"
                                        :format="'YYYY-MM-DD HH:mm'"
                                        :formated="'YYYY-MM-DD HH:mm'"
                                        :button-now-translation="'Hoje'"
                                        :label="'Data'"
                                        :disabled="true"
                                    ></date-picker>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="actionEndInput">Término</label>
                                    <date-picker
                                        :value="actionPlan.end_date"
                                        :output-format="'YYYY-MM-DD HH:mm'"
                                        :format="'YYYY-MM-DD HH:mm'"
                                        :formated="'YYYY-MM-DD HH:mm'"
                                        :button-now-translation="'Hoje'"
                                        :label="'Data'"
                                        :disabled="true"
                                    ></date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="costInput">Custo previsto</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="actionPlan.cost"
                                        v-money="money"
                                        readonly
                                    />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="typeInput">Tipo</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="actionPlan.type.name"
                                    />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="priorInput">Prioridade</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="actionPlan.priority.name"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="howText">Como?</label>
                                    <textarea
                                        class="form-control"
                                        :value="actionPlan.description"
                                        rows="3"
                                        readonly
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="whyText">Porquê?</label>
                                    <textarea
                                        class="form-control"
                                        :value="actionPlan.reason"
                                        rows="3"
                                        readonly
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="$store.getters.user.id == actionPlan.responsible.id" v-show="!answering">
                            <div class="col-4 offset-4">
                                <button class="btn btn-normal btn-block" @click="answer">Responder</button>
                            </div>
                        </div>

                        <div v-show="answering">
                            <hr />
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>O que foi feito?</label>
                                        <textarea
                                            class="form-control"
                                            v-model="actionPlanAnswer.description"
                                            rows="3"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                             <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Anexo</label>
                                        <input type="file" id="answer-file" class='form-control'>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 centered" v-if="actionPlanAnswer.file">
                                    <div class="card" style="width: 18rem;">
                                        <div class="card-body">
                                            <h5 class="card-title mb-4">Anexo</h5>
                                            <i class="fas fa-file fa-3x mb-4"></i>
                                            <p class='mt-2 centered'>{{ getFileName(actionPlanAnswer.file) }}</p>
                                        </div>
                                        <ul class="list-group list-group-flush">
                                            <a
                                                :href="actionPlanAnswer.file_http"
                                                targer="_blank"
                                                class="btn btn-normal-slim mt-3"
                                            >
                                                <i class="fas fa-download"></i>
                                                <br />
                                            </a>
                                        </ul>
                                    </div>
                                </div>
                            </div>                            
                            <!-- Save -->
                            <div class="row justify-content-end mt-4">
                                <div class="col-md-12">
                                    <button class="btn btn-next float-right" @click="save">
                                        Salvar
                                        <i class="fas fa-save"></i>
                                    </button>
                                    <router-link :to="'/worker/actionPlans'" class="btn btn-next float-right mr-2">
                                        Voltar
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            actionPlan: {},
            actionPlanAnswer: {
                description: ''
            },
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "R$ ",
                suffix: "",
                precision: 2,
                masked: false
            },            
            answering: false
        };
    },
    computed: {},
    methods: {
        getFileName(path){
            let pathArray = path.split('/')
            if(pathArray.length > 0){
                return pathArray[pathArray.length - 1]
            } else {
                return path
            }
        },        
        answer() {
            this.answering = true;
        },
        makeFormData() {
            const fd = new FormData();

            fd.append("description", this.actionPlanAnswer.description);
            fd.append("action_plan_id", this.$route.params.id);

            let file = document.getElementById('answer-file').files[0]
            if(file){
                fd.append("file", file);
            }

            if(this.actionPlanAnswer.id){
                fd.append('_method', 'PUT')
            }

            return fd;
        },
        save() {
            const self = this;
            let api = self.$store.state.api + "actionplananswers/";

            if(self.actionPlanAnswer.id){
                api += self.actionPlanAnswer.id
            }

            const fd = self.makeFormData();

            self.$http
                .post(api, fd)
                .then(response => {
                    self.$message(
                        "Sucesso",
                        "Resposta ao Plano de ação salva com sucesso",
                        "success"
                    );
                    self.$router.push("/worker/actionPlans");
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getActionPlan() {
            const self = this;
            const api =
                self.$store.state.api + "actionplans/" + self.$route.params.id;
            self.$http
                .get(api, {
                    params: {
                        with: ["responsible", "type", "priority"]
                    }
                })
                .then(response => {
                    response.data.data[0].cost = response.data.data[0].cost.toFixed(2);
                    self.actionPlan = response.data.data[0];
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getActionPlanAnswer() {
            const self = this;
            const api =
                self.$store.state.api + "actionplananswers?paginated=false"
            self.$http
                .get(api, {
                    params: {
                        action_plan_id: self.$route.params.id
                    }
                })
                .then(response => {
                    if(response.data.data[0]){
                        self.actionPlanAnswer = response.data.data[0]
                        self.answering = true
                    }
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        }
    },
    mounted: function() {
        this.getActionPlan();
        this.getActionPlanAnswer();
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Worker/ActionPlan/Answer.vue